<template>
    <ContactUsSection />
    <MeetSection />
    <ResultsSection />
    <PromSection />
</template>

<script>
import ContactUsSection from '../Resultados/ContactUsSection.vue';
import MeetSection from '../Resultados/MeetSection.vue';
import ResultsSection from '../Resultados/ResultsSection.vue';
import PromSection from '../Resultados/PromSection.vue';

export default {
  name: 'ContactIndex',
  components: {
    ContactUsSection,
    MeetSection,
    ResultsSection,
    PromSection
  }
}
</script>